module.exports = __webpack_public_path__ + "static/media/image1.bafe7bab.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/carAuthorization/img/image1.png
// module id = 326
// module chunks = 0